import { CaravanIcon } from './CaravanIcon';

/**
 * author: GreenTurtwig
 * id 2E5B9249-0FFB-48D0-8A61-2019FD9ED32F
 * name caravan
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/caravan.svg
 * tags
 * - Transportation + Road 
 * - Home Automation 
 * - Automotive 
 */
export const CampingIcon = CaravanIcon;
export default CampingIcon